import { LOCATION_IMG } from '../../../utils/constants';

export const defaultData = {
  Headline: {
    value: '',
  },
  ExternalCTA: {
    value: {},
  },
  ProtonName: {
    value: '',
  },
  City: {
    value: '',
  },
  State: {
    value: '',
  },
  ZipCode: {
    value: '',
  },
  CountryISOCode: {
    value: '',
  },
  NumberOfNearbyLocations: '',
  ParentNameLocation: '',
  OtherLocationsAroundText: {
    value: '',
  },
  LocationPricesTitle: {
    value: '',
  },
  Phone: {
    value: '',
  },
  HeroImage1: {
    value: {
      src: LOCATION_IMG.FIRST.DEFAULT,
    },
    FallBackImage: {
      value: {
        src: LOCATION_IMG.FIRST.FALLBACK,
      },
    },
  },
  HeroImage2: {
    value: {
      src: LOCATION_IMG.SECOND.DEFAULT,
    },
    FallBackImage: {
      value: {
        src: LOCATION_IMG.SECOND.FALLBACK,
      },
    },
  },
  HeroImage3: {
    value: {
      src: LOCATION_IMG.THIRD.DEFAULT,
    },
    FallBackImage: {
      value: {
        src: LOCATION_IMG.THIRD.FALLBACK,
      },
    },
  },
  SolutionsDropdownOptions: [],
  PrimaryCta: {
    value: '',
  },
  SecondaryCta: {
    value: '',
  },
  PricesBySolution: [],
  AtThisLocationTitle: {
    value: '',
  },
  MeetingRoomsTitle: {
    value: '',
  },
  MeetingRoomsQuantity: {
    value: '',
  },
  CoworkingDesksTitle: {
    value: '',
  },
  CoworkingDesksQuantity: {
    value: '',
  },
  PrivateOfficesTitle: {
    value: '',
  },
  PrivateOfficesQuantity: {
    value: '',
  },
  LocationsNearbyTitle: {
    value: '',
  },
  NearbyLocations: {
    value: [],
  },
  Description: {
    value: '',
  },
  Latitude: { value: '0' },
  Longitude: { value: '0' },
};
